/** @typedef {import('./QueuePromises.svc')} Types */

export class QueuePromises {
	constructor() {
		this.queue = [];
	}

	/**
	 * @param {unknown} [name]
	 * @returns {boolean}
	 */
	add(name) {
		return this.queue.push(name ? name : true) > 0;
	}

	/**
	 * @param {unknown} [name]
	 * @returns {boolean}
	 */
	subs(name) {
		if (name) {
			this.queue = this.queue.filter(i => i !== name);
			return this.queue.includes(name);
		} else {
			this.queue.pop();
		}
		return this.queue.length > 0;
	}

	/** @returns {false} */
	reset() {
		this.queue = [];
		return false;
	}
}
//
let compMod = angular.module('mod.svc.QueuePromisesSvc', []).service('QueuePromisesSvc', QueuePromises);
export default (compMod = compMod.name);
